<template>
    <kgr-icon
        icon-class="euro"
        circle
        :title="$t('Mahnwesen ist aktiviert')"
        class="dunning-icon"
    />
</template>

<script>
import Icon from '../common/icon/Icon.vue';

export default {
    name: 'kgr-member-dunning-icon',
    components: {
        'kgr-icon': Icon,
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .dunning-icon {
        background-color: var(--kgr-color-error);
    }
</style>
